
const initialState = {
    globalView: "workstations",
    selectedStation: null,
    selectedPart: null,
};

export const analyticsStateTrackReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case "SET_GLOBAL_VIEW_AND_SELECTED_ITEM":
            return {
                ...state,
                globalView: action.payload.globalView,
                selectedStation: action.payload.selectedStation,
                selectedPart: action.payload.selectedPart,
            };
        default:
            return state;
    }
};